// @ts-check
import React, { useState } from 'react'
import { useStore } from '../../../StateProvider'
import { map } from 'ramda'
import { useResidenceDependentVisibility } from '../../utils/hooks'
import { ExternalTextField } from '..'

const residenceDependentFields = ['branchName', 'bankName', 'bankAccountNumber', 'bankAccountName']

/**
 * @param {{
 * i18n: string,
 * type: string,
 * name: string,
 * maxlength?: number,
 * additionalInfo?: string,
 * required: boolean,
 * order?: number,
 * requiredForCountries?: string[],
 * allowNonLatin: boolean
 * }} props
 */
const ExternalTextCountryDependent = ({
  i18n,
  type,
  name,
  maxlength,
  additionalInfo,
  required,
  order,
  requiredForCountries,
  allowNonLatin
}) => {
  const [isShown, setIsShown] = useState(false)
  const [{ form, form: { accId } }, dispatch] = useStore()
  const { residenceCountry } = form[accId]

  const onHide = () => {
    setIsShown(false)
    dispatch({ type: 'removeValidationFld', name })
  }

  const onShow = () => {
    setIsShown(true)
    dispatch({ type: 'addValidationFld', name })
  }

  useResidenceDependentVisibility({
    residenceCountry, requiredForCountries, name, residenceDependentFields, onHide, onShow
  })

  return isShown ? (
    <ExternalTextField
      i18nLabel={i18n}
      name={name}
      required={required}
      type={type}
      key={name}
      order={order}
      additionalInfo={additionalInfo}
      maxlength={maxlength}
      allowNonLatin={allowNonLatin}
    />
  ) : null
}

const getExternalTextCountryDependentFields = map(textField => {
  return (
    <ExternalTextCountryDependent {...textField} />
  )
})

export { ExternalTextCountryDependent, getExternalTextCountryDependentFields }
